export default __webpack_public_path__ + "static/B0255-220a95501af0c839ac991bf26eb34b9c.png";